module.exports = __webpack_public_path__ + "img/arrowright-brown.be531ff2.svg";